import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Activate from "@/pages/Activate";
import SuccessHub from "@/pages/SuccessHub";
import Privacy from "@/pages/Privacy";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App vault-grain">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/activate" element={<Activate />} />
          <Route path="/success-hub" element={<SuccessHub />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default App;
